export default {
  namespaced: true,
  state: {
    sheetId: "1qw8sW9TG4oNqy2UR32L6ee91M7_1P0zg1WiJ9GYAOw8",
    allSheets: [
      "type",
      "tag",
      "spendCategory",
      "transactionType",
      "payMethod",
      "vendor",
      "receipt",
      "trip",
      "taxCategory",
      "exercise",
      "muscleGroup",
      "meals",
      "account",
      "money",
      "food",
      "activity",
    ],
    sheetsObj: {},
    totals: {
      money: [],
      activity: {
        exercise: [],
        muscleGroup: [],
      },
      food: {},
    },
  },
  mutations: {
    UPDATE_SHEETSOBJ: (state, sheetsObj) => {
      state.sheetsObj = sheetsObj;
    },
    UPDATE_SHEETS_STATE: (state, payload) => {
      if (payload.field && payload.subfield) {
        state[payload.state][payload.field][payload.subfield] = payload.value;
      } else if (payload.field) {
        state[payload.state][payload.field] = payload.value;
      } else {
        state[payload.state] = payload.value;
      }
    },
  },
  actions: {
    updateSheetsObj: ({ commit }, sheetsObj) => {
      commit("UPDATE_SHEETSOBJ", sheetsObj);
    },
    updateSheetsState: ({ commit }, payload) => {
      commit("UPDATE_SHEETS_STATE", payload);
    },
  },
};
